import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { ENDPOINTS } from "../../../constants/ApiEndPoints";
import { getService, postService } from "../../../services/ApiServices";
import { properties } from "../../../util/Properties";
import {
  removeSessionStorage,
  setSessionStorage,
} from "../../../util/UtilMethods";
import { SESSION_STORAGE_KEYS } from "../../../constants/constant";

const initialState = {
  isLoading: false,
  userData: {},
  categoriesList: [],
  typeOfCategoriesList: [],
  countriesList: [],
};

export const addQueryData = createAsyncThunk(
  "service/addQueryData",
  async (requestBody, thunkAPI) => {
    try {
      const response = await postService(
        `${ENDPOINTS.POST_QUERY_DATA}?p_auth=${properties.authToken}`,
        requestBody
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue("something went wrong");
    }
  }
);

export const getCategories = createAsyncThunk(
  "service/getCategories  ",
  async (requestBody, thunkAPI) => {
    try {
      const response = await getService(
        `${ENDPOINTS.LIST_TYPE_DEFINITION}?p_auth=${properties.authToken}`
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue("something went wrong");
    }
  }
);

export const getTypeOfCategories = createAsyncThunk(
  "service/getTypeOfCategories  ",
  async (requestBody, thunkAPI) => {
    try {
      const response = await getService(
        `${ENDPOINTS.TYPE_OF_CATEGORY}${requestBody.categoryType}&locale=${requestBody.language}&p_auth=${properties.authToken}`
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue("something went wrong");
    }
  }
);

export const getCountries = createAsyncThunk(
  "service/getCountries  ",
  async (requestBody, thunkAPI) => {
    try {
      const response = await getService(
        `${ENDPOINTS.COUNTRIES}?fields=a3,idd&pageSize=300&p_auth=${properties.authToken}`
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue("something went wrong");
    }
  }
);

const formSlice = createSlice({
  name: "formSlice",
  initialState,
  reducers: {
    addUserDetails: (state, { payload }) => {
      state.userData = payload;
    },
    clearFormSlice: (state, action) => {
      state.isLoading = false;
      state.userData = {};
      state.categoriesList = [];
      state.typeOfCategoriesList = [];
      state.countriesList = [];
      removeSessionStorage(SESSION_STORAGE_KEYS.USER_DETAILS);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addQueryData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addQueryData.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.userData = payload;
        setSessionStorage(
          SESSION_STORAGE_KEYS.USER_DETAILS,
          JSON.stringify(payload)
        );
      })
      .addCase(addQueryData.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getCategories.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCategories.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.categoriesList = payload.items;
      })
      .addCase(getCategories.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getTypeOfCategories.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTypeOfCategories.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.typeOfCategoriesList = payload;
      })
      .addCase(getTypeOfCategories.rejected, (state) => {
        state.isLoading = false;
        state.typeOfCategoriesList = [];
      })
      .addCase(getCountries.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCountries.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        let countryAPIList = payload.items.map((country) => ({
          value: country.idd,
          label: country.a3,
        }));
        state.countriesList = 
        [
        ...(countryAPIList.sort((a, b) => (a.label).localeCompare(b.label)))];
      })
      .addCase(getCountries.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { addUserDetails, clearFormSlice } = formSlice.actions;
export default formSlice.reducer;
